var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.76558 10.6292C5.83723 10.5581 5.8941 10.4736 5.93291 10.3804C5.97172 10.2873 5.9917 10.1873 5.9917 10.0864C5.9917 9.98551 5.97172 9.88559 5.93291 9.79244C5.8941 9.69928 5.83723 9.61474 5.76558 9.54367L2.26448 6.04257C2.19283 5.97151 2.13596 5.88696 2.09715 5.79381C2.05834 5.70066 2.03836 5.60074 2.03836 5.49983C2.03836 5.39891 2.05834 5.299 2.09715 5.20584C2.13596 5.11269 2.19283 5.02814 2.26448 4.95708L5.76558 1.45598C5.83723 1.38491 5.8941 1.30037 5.93291 1.20721C5.97172 1.11406 5.9917 1.01415 5.9917 0.913232C5.9917 0.812317 5.97172 0.712402 5.93291 0.619249C5.8941 0.526095 5.83723 0.441548 5.76558 0.370485C5.62236 0.228108 5.42861 0.148193 5.22666 0.148193C5.0247 0.148193 4.83096 0.228108 4.68773 0.370485L1.17899 3.87923C0.749528 4.30922 0.508304 4.8921 0.508304 5.49983C0.508304 6.10755 0.749528 6.69043 1.17899 7.12042L4.68773 10.6292C4.83096 10.7715 5.0247 10.8515 5.22666 10.8515C5.42861 10.8515 5.62236 10.7715 5.76558 10.6292Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.b9eee3230f8cff7ee9e7b7bf5ba95051.svg";
export { ForwardRef as ReactComponent };